import { createInventoryCategory } from "../../api/inventoryService";

export const useCreateInventoryCategory = (successCallback) => {
    const create = async (data) => {
        try {
            const newInventoryCategory = await createInventoryCategory(data);
            if (successCallback)
            {
                successCallback(newInventoryCategory);
            }
            return newInventoryCategory;
        } catch (error) {
            console.error("Failed to create inventory category:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};